/** Tashkeel (U+064B–U+065F), superscript alef (U+0670) and tatweel (U+0640). */
const DIACRITICS = /[ً-ٰٟـ]/g

const EQUIVALENTS: Array<[RegExp, string]> = [
  [/[أإآٱ]/g, 'ا'], // أ إ آ ٱ  →  ا
  [/ة/g, 'ه'], //             ة  →  ه
  [/ى/g, 'ي'], //             ى  →  ي
  [/ؤ/g, 'و'], //             ؤ  →  و
  [/ئ/g, 'ي'], //             ئ  →  ي
]

/**
 * Fold an Arabic string to a comparable form for search.
 *
 * Admins type `الاعدادات` for a menu labelled `الاعدادت`, `مزودى` for `مزودي`,
 * and `الاشعارات` for `الإشعارات`. Without folding hamza forms, taa marbuta and
 * alef maqsura — and stripping diacritics — a literal `includes` misses all of
 * these and the palette reads as broken.
 */
export function normalizeArabic(value: string): string {
  if (!value) return ''
  let out = value.normalize('NFKD').replace(DIACRITICS, '')
  for (const [pattern, replacement] of EQUIVALENTS) {
    out = out.replace(pattern, replacement)
  }
  return out.toLowerCase().trim()
}

/** True when every whitespace-separated term in `query` appears in `haystack`. */
export function matchesQuery(query: string, haystack: string[]): boolean {
  const terms = normalizeArabic(query).split(/\s+/).filter(Boolean)
  if (!terms.length) return true
  const target = haystack.map(normalizeArabic).join(' ')
  return terms.every((term) => target.includes(term))
}
